var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tw-mb-4 md:tw-mb-5 text-center"},[_c('p',{staticClass:"quoted-text"},[_vm._v("\""+_vm._s(_setup.props.content)+"\"")])])
}
var staticRenderFns = []

export { render, staticRenderFns }